<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-logos__type" @click="sortColumn('name')">
						<div class="th-sort">
							<span>{{ $t('logoName') }}</span>
							<span v-if="sortedColumn === 'name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"></svgicon>
							</span>
						</div>
					</th>
					<th class="th-logos__type" @click="sortColumn('simulationType_ID')">
						<div class="th-sort">
							<span>{{ $t('simType') }}</span>

							<span v-if="sortedColumn === 'simulationType_ID'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"></svgicon>
							</span>
						</div>
					</th>
					<th class="th-logos__type" @click="sortColumn('isLocalSponsor')">
						<div class="th-sort">
							<span>{{ $t('sponsorType') }}</span>
							<span v-if="sortedColumn === 'isLocalSponsor'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"></svgicon>
							</span>
						</div>
					</th>
					<th class="th-logos__active" @click="sortColumn('isActive')">
						<div class="th-sort">
							<span>{{ $t('active') }}</span>
							<span v-if="sortedColumn === 'isActive'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"></svgicon>
							</span>
						</div>
					</th>
					<th class="th-logos__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr
					v-for="(row, index) in displayedData"
					:key="index"
					class="table-row"
				>
					<td>{{ row.name }}</td>
					<td>{{ getNameSimulationType(row.simulationType_ID) }}</td>
					<td>
						{{ getSponsorName(row.isNationalSponsor, row.isLocalSponsor) }}
					</td>
					<td>{{ getActiveName(row.isActive) }}</td>
					<td class="td-center">
						<button class="action-button" @click="editRow(row)">
							<svgicon name="pencil"></svgicon>
						</button>
						<button class="action-button" @click="openDeleteModal(row)">
							<svgicon name="trash"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="data.length"
			@changePage="setAllPage"
		></ja-pagination>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteSponsorLogo()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: rowDelete ? rowDelete.name : ''
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import {
	simulationTypeArray,
	isActive,
	sponsorNames
} from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaPagination: Pagination
	},
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			currentPage: 1,
			itemsPerPage: 15,
			rowDelete: null
		};
	},
	computed: {
		displayedData() {
			let filteredData = this.data;
			if (this.sortedColumn) {
				filteredData = filteredData.sort((a, b) => {
					const fieldA = a[this.sortedColumn];
					const fieldB = b[this.sortedColumn];
					return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
				});
			}
			const start = (this.currentPage - 1) * this.itemsPerPage;
			filteredData = filteredData.slice(start, start + this.itemsPerPage);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	methods: {
		getNameSimulationType(simulationTypeID) {
			for (const simulation of simulationTypeArray) {
				if (simulation.id === simulationTypeID) {
					return simulation.name;
				}
			}
			return '--';
		},
		getActiveName(onActive) {
			for (const added of isActive) {
				if (added.value === onActive) {
					return this.$t(added.name);
				}
			}
			return '--';
		},
		getSponsorName(isNational, isLocal) {
			if (isNational) {
				return sponsorNames[0].name;
			}
			if (isLocal) {
				return sponsorNames[1].name;
			} else {
				return '';
			}
		},
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			this.$emit('editRow', row);
		},
		openDeleteModal(row) {
			this.rowDelete = row;
			this.showMessageDeletionModal = true;
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		deleteSponsorLogo() {
			this.$emit('deleteRow', this.rowDelete);
			this.showMessageDeletionModal = false;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.th-logos {
	&__type {
		width: 25%;
	}
	&__active {
		width: 10%;
	}
	&__actions {
		width: 15%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}

.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
